/**
 * The answer key of a peg solitaire is a sequence of jumps. Kept apart from the form component
 * so the eagerly loaded module file never pulls the author's board into the player bundle.
 */
import { parseBoard, replay } from "./board";
import { sanitizeMoves } from "./progress";
import type { Move, PegSolitaireDefinition, PegSolitaireSolution } from "./types";

/** Nothing played yet: an empty sequence, which `validate_solution` refuses on save. */
export function emptySolution(_definition: PegSolitaireDefinition): PegSolitaireSolution {
  return { moves: [] };
}

/** Whether a stored value is a sequence of jumps at all. */
export function isJumpList(value: unknown): value is PegSolitaireSolution {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  return Array.isArray((value as { moves?: unknown }).moves);
}

/** Reads whatever is stored, however wrong, as the jumps this board can play. */
export function movesOf(value: unknown, definition: PegSolitaireDefinition): Move[] {
  if (!isJumpList(value)) return [];
  const { board, pegs } = parseBoard(definition.board);
  return replay(board, pegs, sanitizeMoves(value.moves)).moves;
}
